import React, { useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { contractorSchema } from "./schema/contractor";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  buttonAdd: {
    marginLeft: theme.spacing(1),
  },
}));

const Edit = (props) => {
  const classes = useStyles();
  const {
    isEnabledFormEditAdmin,
    editHandler,
    loading,
    show,
    currentContractor,
    translateValidation,
  } = props;
  const { register, handleSubmit, errors, reset } = useForm({
    resolver: yupResolver(contractorSchema(translateValidation)),
  });

  const [inputState, setInputState] = useState({
    name: currentContractor?.name,
    email: currentContractor?.email,
    cnpj: currentContractor?.cnpj,
  });

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevVisibility = usePrevious(currentContractor);

  useEffect(() => {
    if (prevVisibility !== currentContractor) {
      const newState = {
        ...inputState,
        name: currentContractor.name,
        email: currentContractor.email,
        cnpj: currentContractor.cnpj,
      };
      setInputState(newState);
    }
  }, [currentContractor, inputState, prevVisibility]);

  const onsubmit = (data) => {
    reset();
    editHandler(data);
  };

  const handleCancel = () => {
    reset();
    show();
  };

  const handleChangeInput = (event) => {
    setInputState({
      ...inputState,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Box component="span" display={isEnabledFormEditAdmin ? "none" : "block"}>
      <Paper elevation={1}>
        <Container maxWidth={false} className={classes.container}>
          <Typography
            className={classes.title}
            variant="h5"
            component="h1"
            gutterBottom
          >
            {translateValidation.title}
          </Typography>

          <form fullWidth onSubmit={handleSubmit(onsubmit)} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.name && true}
                  helperText={errors.name && errors.name.message}
                  id="name"
                  name="name"
                  label={translateValidation.name.label}
                  value={inputState.name}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.name.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.email && true}
                  helperText={errors.email && errors.email.message}
                  id="email"
                  name="email"
                  label={translateValidation.email.label}
                  value={inputState.email}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.email.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={4}>
                <TextField
                  inputRef={register}
                  error={errors.cnpj && true}
                  helperText={errors.cnpj && errors.cnpj.message}
                  id="cnpj"
                  name="cnpj"
                  label={translateValidation.cnpj.label}
                  value={inputState.cnpj}
                  onChange={handleChangeInput}
                  placeholder={translateValidation.cnpj.placeholder}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={12} lg={12}>
                <div className={classes.buttons}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={() => handleCancel()}
                  >
                    {translateValidation.cancelButton}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.buttonAdd}
                    disabled={loading}
                  >
                    {translateValidation.confirmButton}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>
    </Box>
  );
};

Edit.propTypes = {
  isEnabledFormEditAdmin: PropTypes.object.isRequired,
  editHandler: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  currentContractor: PropTypes.object.isRequired,
};

export default Edit;
